import { render, staticRenderFns } from "./pdf-viewer.html?vue&type=template&id=30a40a7c&scoped=true&external"
import script from "./pdf-viewer.js?vue&type=script&lang=js&external"
export * from "./pdf-viewer.js?vue&type=script&lang=js&external"
import style0 from "./pdf-viewer.scss?vue&type=style&index=0&id=30a40a7c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a40a7c",
  null
  
)

export default component.exports